import React, { Component } from 'react';
import Icon from '../Icon/Icon';
import Contact from '../Contact/Contact';
import Toast from '../Toast/Toast';
import config from '../../config';
require('./Footer.scss');

class Footer extends Component {
	constructor(props) {
		super(props);
		this.links = {
			social: [
				{
					title: 'Facebook', route: config.social.facebook, icon: 'ion ion-facebook'
				},
			]
		}
	}

	getCurrentYear() {
		let date = new Date();
		return date.getFullYear();
	}

	render() {
		return (
			<div>
				<div id="footer" className="Footer Section--accented">
					<div className="container">
						<div className="row flex-items-xs-top">
							<div className="col-xs-12 col-md-4 pull-md-left text-xs-center text-md-left">
								<Contact />
							</div>
							<div className="col-xs-12 col-md-4 pull-md-left text-xs-center">
								<div className="Footer-social">
									<span className="Footer-socialCopy Heading--light Heading--xs Heading--strong">Follow us on</span>
									{this.links.social.map((link) => {
										return (
											<Icon key={link.title} route={link.route} title={link.title} classes="Icon--branded Icon--rounded Icon--bordered Icon--spacedLeft Icon--small" icon={link.icon}></Icon>
										)
									})}
								</div>
							</div>
						</div>
						<div className="row flex-items-xs-top">
							<div className="col-xs-12">
								<div className="Footer-copyright text-xs-center Text--fadedWhite Text--xs">
									Copyright &copy; {this.getCurrentYear()}, Magic Card Buyer.<br className="hidden-lg-up" /> All rights reserved.
								</div>
							</div>
						</div>
					</div>
				</div>
				<Toast />
			</div>
		);
	}
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer/Footer.js
 **/